import ModuleShow from './ModuleShow';
// import ModuleList from './ModuleList';
import ModuleCreate from './ModuleCreate';
import ModuleEdit from './ModuleEdit';
import ModuleList from './Search/ModuleSearch';

export default {
    list: ModuleList,
    create: ModuleCreate,
    edit: ModuleEdit    
};
